
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_tgrfs_141",
  "variant-recovery": "awsui_variant-recovery_4c84z_tgrfs_209",
  "variant-secondary": "awsui_variant-secondary_4c84z_tgrfs_242",
  "variant-primary": "awsui_variant-primary_4c84z_tgrfs_277",
  "variant-info": "awsui_variant-info_4c84z_tgrfs_310",
  "variant-value-large": "awsui_variant-value-large_4c84z_tgrfs_345",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_tgrfs_377",
  "button": "awsui_button_4c84z_tgrfs_412",
  "color-inverted": "awsui_color-inverted_4c84z_tgrfs_447",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_tgrfs_468",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_tgrfs_476",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_tgrfs_483",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_tgrfs_491",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_tgrfs_499",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_tgrfs_507",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_tgrfs_515",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_tgrfs_523",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_tgrfs_531",
  "in-inline-token": "awsui_in-inline-token_4c84z_tgrfs_539",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_tgrfs_543",
  "icon": "awsui_icon_4c84z_tgrfs_543"
};
  